<template>
  <v-main>
    <h1>Overview</h1>
    <p>
      <b>Instructions: </b>
      Each location can have it's own unique compset. By default we've populated
      each location's compset with nearby competitors that have the greatest
      share of wallet with that location. You may change your compset as you see
      fit. Please note that you are required to add a minumum of 5(five) stores
      to each location's compset and not more than 1(one) store can be from the
      same brand.
    </p>
    <input class="search" v-model="query" placeholder="Search" />
    <div class="row title">
      <div class="col">Name</div>
      <div class="d-none d-lg-block col">ZIP</div>
      <div class="d-none d-lg-block col">Compset Configured</div>
      <div class="col">Configure</div>
    </div>

    <div class="location" v-for="location in locations" :key="location.id">
      <div
        class="row"
        v-if="
          !query || location.name.toLowerCase().includes(query.toLowerCase())
        "
      >
        <div class="col">{{ location.name }}</div>
        <div class="d-none d-lg-block col">{{ location.zip || "-" }}</div>
        <div
          :class="[
            location.compset_configured ? 'true' : 'false',
            'd-none',
            'd-lg-block',
            'col',
            'bool'
          ]"
        >
          {{ location.compset_configured ? "Yes" : "No" }}
        </div>
        <div class="col">
          <router-link
            :to="{
              name: 'compset-map-view',
              params: { selectedLocationId: location.id }
            }"
          >
            <button class="btn btn-primary"></button>
          </router-link>
        </div>
      </div>
    </div>
  </v-main>
</template>

<script>
import { getLocations } from "@/api/locations";

export default {
  name: "compset-overview",

  data() {
    return {
      locations: [],
      query: ""
    };
  },
  async created() {
    this.locations = await getLocations()
      .then(res => Array.isArray(res) && res)
      .catch(error => {
        console.error(error);
        return [];
      });
  }
};
</script>

<style scoped>
.title {
  font-weight: bold;
  background: inherit;
  margin-bottom: 1.2rem;
}

.location {
  margin-bottom: 0.9rem;
}

.true {
  color: green;
}

.false {
  color: red;
}

.search {
  width: 50%;
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  outline: none;
}

h1 {
  margin-bottom: 3rem;
  /* text-align: center; */
}

div {
  text-align: left;
  /* border: 1px solid black; */
}
</style>
